import { toggleClass, toggleAttr, ready } from './helpers';
import { slideUp, slideToggle } from './slideToggle';

/**
 * Toggle the menu
 * Lets make this CSS only!
 */

export default class Menu {
    menu: HTMLElement;
    submenus: NodeListOf<Element>;

    constructor(toggle: HTMLElement, menu: HTMLElement) {
        this.menu = menu;
        toggle.addEventListener('click', (e: Event) => this.toggle(e));

        // submenus
        this.submenus = menu.querySelectorAll('.menu-item-has-children > a');
        if (this.submenus.length) {
            for (let i = 0; i < this.submenus.length; i++) {
                this.submenus[i].addEventListener('click', (e: Event) => this.toggleSubmenu(e));
            }
        }
    }

    toggle(e: Event) {
        toggleClass(e.target, 'toggled');
        toggleClass(document.body, 'menu-toggled');
        toggleAttr(e.target, 'aria-expanded');
    }

    toggleSubmenu(e: Event) {
        e.preventDefault();
        const parent = (<Element>e.target).parentNode;
        const submenu = parent.querySelector('.sub-menu');
        if (!submenu) {
            return;
        }

        const openMenuParents = this.menu.querySelectorAll('.menu-parent-opened');
        const openSubmenus = this.menu.querySelectorAll('.menu-opened');

        if ((<Element>parent.parentNode).classList.contains('menu') && openMenuParents && openSubmenus) {
            for (let i = 0; i < openMenuParents.length; i++) {
                slideUp(openSubmenus[i]);
                openMenuParents[i].classList.remove('menu-parent-opened');
                openSubmenus[i].classList.remove('menu-opened');
            }
        }
        slideToggle(submenu);
        toggleClass(parent, 'menu-parent-opened');
        toggleClass(submenu, 'menu-opened');
    }

}
